(() => {
  const initialized = new WeakSet();
  const groups = ['style', 'stock', 'color', 'size', 'config'];
  const optionPositions = {color: 'colorPosition', size: 'sizePosition', config: 'configPosition'};
  const colorMap = {'orange':'#d98736','electro silver':'#c4c8ca','titanium grey':'#858a8e','black':'#222','matte black':'#242424','dark gray':'#54575a','matte dark gray':'#55585b','cement gray':'#b1b4b3','silver':'#bfc3c6','satin silver':'#bfc3c6','matte titanium gray':'#858a8e','emerald dark green':'#294236','cosmic black':'#111111','dark green':'#344b39','tiffany blue':'#7cc9c7','dark red':'#7d353a','red':'#b34440','matte black red':'#3d2828','dark gray black':'linear-gradient(135deg,#707477 50%,#222 50%)','dark green black':'linear-gradient(135deg,#3b5342 50%,#222 50%)','red black':'linear-gradient(135deg,#aa3639 50%,#222 50%)','black red':'linear-gradient(135deg,#222 50%,#aa3639 50%)','black blue':'linear-gradient(135deg,#222 50%,#4a738a 50%)','black gray':'linear-gradient(135deg,#222 50%,#9b9c9e 50%)'};
  const text = (tag, content, className) => {const node = document.createElement(tag); node.textContent = content; if (className) node.className = className; return node;};
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const labels = JSON.parse(root.querySelector('[data-ct-cl-labels]').textContent);
    const list = root.querySelector('[data-ct-cl-products]');
    const filterForm = root.querySelector('[data-ct-cl-filter-form]');
    const fields = root.querySelector('[data-ct-cl-filter-fields]');
    const minInput = root.querySelector('[data-ct-cl-min]');
    const maxInput = root.querySelector('[data-ct-cl-max]');
    const filterDialog = root.querySelector('[data-ct-cl-filters]');
    const compareDialog = root.querySelector('[data-ct-cl-compare-dialog]');
    const media = matchMedia('(max-width: 900px)');
    const params = new URL(location.href).searchParams;
    const selections = new Map();
    let records = [];
    let page = Math.max(1, Math.floor(Number(params.get('ct_page'))) || 1);
    const pageSize = Number(root.dataset.pageSize) || 12;
    let preference = 'grid';
    try {preference = localStorage.getItem('cyctracCollectionView') || 'grid';} catch {}
    let view = params.get('ct_view') || preference;
    if (!['grid', 'list'].includes(view)) view = 'grid';
    let complete = false;
    let priceTimer;
    let state = {style: [], stock: [], color: [], size: [], config: [], min: null, max: null};
    const format = (value, count) => value.replace('[count]', String(count));
    const readRecord = (card) => {
      const product = JSON.parse(card.querySelector('[data-ct-cl-product]').textContent);
      return {card, product, selectedColor: '', matching: product.variants, variant: null};
    };
    records = [...list.querySelectorAll('[data-ct-cl-card]')].map(readRecord);
    root.classList.add('ct-cl-ready');
    fields.disabled = true;
    const syncDialog = () => {if (media.matches && filterDialog.open) filterDialog.close(); document.documentElement.classList.remove('ct-cl-modal-open'); if (!media.matches && !filterDialog.open) filterDialog.show();};
    syncDialog();
    media.addEventListener('change', syncDialog);
    filterDialog.addEventListener('close', () => document.documentElement.classList.remove('ct-cl-modal-open'));
    function closeFilters() {if (media.matches && filterDialog.open) filterDialog.close();}
    function setView(value, save = true) {
      view = value;
      root.dataset.view = value;
      root.querySelectorAll('[data-ct-cl-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ctClView === value)));
      if (save) {try {localStorage.setItem('cyctracCollectionView', value);} catch {} updateUrl();}
    }
    setView(view, false);
    function getState() {
      const next = Object.fromEntries(groups.map(group => [group, [...filterForm.querySelectorAll(`input[name="ct_${group}"]:checked`)].map(input => input.value)]));
      next.min = minInput.value === '' ? null : Math.max(0, Number(minInput.value));
      next.max = maxInput.value === '' ? null : Math.max(0, Number(maxInput.value));
      return next;
    }
    const configurationValue = (product,variant) => {
      const value = variant.options[product.configPosition-1];
      const tier = variant.tier || product.options?.[product.configPosition-1]?.values.find(option => option.value === value)?.tier || 0;
      return tier > 0 ? 'tier'+tier : value;
    };
    const filterName = (group,value) => {
      if (group === 'stock') return labels[value === 'in' ? 'available' : 'unavailable'];
      if (group === 'style') return labels[value] || value;
      if (group === 'config' && /^tier[1234]$/.test(value)) {
        const tier = Number(value.slice(4));
        const option = records.flatMap(record => record.product.options || []).find(option => option.kind === 'configuration' && option.values.some(value => value.tier === tier));
        return option?.values.find(value => value.tier === tier)?.label.split(' · ')[0] || value;
      }
      return value;
    };
    function variantMatches(product, variant, criteria, omit) {
      if (omit !== 'style' && criteria.style.length && !criteria.style.includes(product.style)) return false;
      if (omit !== 'stock' && criteria.stock.length && !criteria.stock.includes(variant.available ? 'in' : 'out')) return false;
      for (const group of ['color','size','config']) {
        if (group === omit || !criteria[group].length) continue;
        const position = product[optionPositions[group]];
        const value = group === 'config' ? configurationValue(product,variant) : variant.options[position - 1];
        if (!position || (!criteria[group].includes(value) && !(group === 'config' && criteria[group].includes(variant.options[position-1])))) return false;
      }
      if (omit !== 'price' && criteria.min !== null && variant.price < Math.round(criteria.min * 100)) return false;
      if (omit !== 'price' && criteria.max !== null && variant.price > Math.round(criteria.max * 100)) return false;
      return true;
    }
    function hasValue(product, variant, group, value) {
      if (group === 'style') return product.style === value;
      if (group === 'stock') return (variant.available ? 'in' : 'out') === value;
      const position = product[optionPositions[group]];
      return position > 0 && (group === 'config' ? configurationValue(product,variant) : variant.options[position - 1]) === value;
    }
    function optionValues(group) {
      if (group === 'stock') return ['in', 'out'];
      const values = new Set();
      records.forEach(({product}) => {
        if (group === 'style') {if (product.style) values.add(product.style); return;}
        const position = product[optionPositions[group]];
        if (position) product.variants.forEach(variant => values.add(group === 'config' ? configurationValue(product,variant) : variant.options[position - 1]));
      });
      return [...values].filter(Boolean).sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
    }
    function createOptions() {
      groups.forEach(group => {
        const container = root.querySelector(`[data-ct-cl-options="${group}"]`);
        const values = optionValues(group);
        container.replaceChildren();
        container.closest('details').hidden = values.length === 0;
        values.forEach(value => {
          const label = document.createElement('label');
          label.className = 'ct-cl-option';
          const input = document.createElement('input'); input.type = 'checkbox'; input.name = `ct_${group}`; input.value = value;
          input.checked = params.getAll(`ct_${group}`).includes(value);
          const name = filterName(group,value);
          label.append(input, text('span', name), text('small', ''));
          container.append(label);
        });
      });
      const prices = records.flatMap(({product}) => product.variants.map(variant => variant.price));
      maxInput.placeholder = String(Math.ceil(Math.max(0, ...prices) / 100));
      for (const [input,key] of [[minInput,'ct_min'],[maxInput,'ct_max']]) {
        const value = params.get(key);
        input.value = value !== null && value.trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
      }
      state = getState();
    }
    function createSwatches(record) {
      const {product,card} = record;
      const container = card.querySelector('[data-ct-cl-swatches]');
      if (!product.colorPosition) {container.hidden = true; return;}
      const colors = [...new Set(product.variants.map(variant => variant.options[product.colorPosition - 1]))];
      colors.forEach(color => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.ctClColor = color;
        button.setAttribute('aria-label', color); button.setAttribute('aria-pressed', 'false'); button.title = color;
        button.style.background = colorMap[color.toLowerCase()] || '#a2a6a3';
        container.append(button);
      });
    }
    function renderVariant(record, matches) {
      record.matching = matches;
      let choices = matches;
      if (record.selectedColor && record.product.colorPosition) {
        const preferred = choices.filter(variant => variant.options[record.product.colorPosition - 1] === record.selectedColor);
        if (preferred.length) choices = preferred;
      }
      const available = choices.filter(variant => variant.available);
      if (available.length) choices = available;
      const variant = [...choices].sort((a,b) => a.price - b.price)[0];
      if (!variant) return;
      record.variant = variant;
      const card = record.card;
      card.dataset.ctSelectedVariantId = String(variant.id);
      const cardInput = card.querySelector('[data-ct-card-variant]');if (cardInput) cardInput.value = String(variant.id);
      const cardAdd = card.querySelector('[data-ct-pd-add]');if (cardAdd) {cardAdd.disabled = !record.product.variants.some(value => value.available);}
      card.querySelector('[data-ct-cl-price]').textContent = variant.priceText;
      card.querySelector('[data-ct-cl-from]').hidden = choices.every(value => value.price === variant.price);
      const comparePrice = card.querySelector('[data-ct-cl-compare-price]');
      comparePrice.hidden = variant.compareAt <= variant.price;
      comparePrice.textContent = variant.compareAtText;
      const sale = card.querySelector('[data-ct-cl-sale]'); sale.hidden = variant.compareAt <= variant.price; sale.textContent = `${labels.save} ${variant.saving}`;
      card.querySelectorAll('[data-ct-cl-product-link]').forEach(link => {link.href = `${record.product.url}?variant=${variant.id}`;});
      const action = card.querySelector('.ct-cl-card__actions [data-ct-cl-product-link]');
      action.textContent = matches.some(value => value.available) ? labels.view_product : labels.sold_out;
      const image = card.querySelector('.ct-cl-card__image');
      const src = variant.image || record.product.image;
      if (image && src && image.getAttribute('src') !== src) {image.removeAttribute('srcset'); image.src = src;}
      card.querySelectorAll('[data-ct-cl-color]').forEach(button => {
        button.setAttribute('aria-pressed', String(variant.options[record.product.colorPosition - 1] === button.dataset.ctClColor));
        button.disabled = !matches.some(value => value.options[record.product.colorPosition - 1] === button.dataset.ctClColor);
      });
    }
    function updateCounts() {
      groups.forEach(group => root.querySelectorAll(`[data-ct-cl-options="${group}"] input`).forEach(input => {
        const count = records.filter(({product}) => product.variants.some(variant => variantMatches(product,variant,state,group) && hasValue(product,variant,group,input.value))).length;
        input.closest('label').querySelector('small').textContent = `(${count})`;
        input.disabled = count === 0 && !input.checked;
      }));
    }
    function updateUrl() {
      if (!complete) return;
      const url = new URL(location.href);
      ['style','stock','color','size','config','min','max','page','view'].forEach(key => url.searchParams.delete(`ct_${key}`));
      groups.forEach(group => state[group].forEach(value => url.searchParams.append(`ct_${group}`,value)));
      if (state.min !== null) url.searchParams.set('ct_min',String(state.min));
      if (state.max !== null) url.searchParams.set('ct_max',String(state.max));
      if (page > 1) url.searchParams.set('ct_page',String(page));
      if (view === 'list') url.searchParams.set('ct_view','list');
      url.searchParams.delete('page');
      history.replaceState(null,'',url);
    }
    function chips() {
      const container = root.querySelector('[data-ct-cl-active-filters]');
      container.replaceChildren();
      const add = (name,remove) => {const button = text('button',''); button.type='button'; button.setAttribute('aria-label',`${labels.remove}: ${name}`); button.append(text('span',name),text('span','×')); button.addEventListener('click',remove); container.append(button);};
      groups.forEach(group => state[group].forEach(value => {
        const name = filterName(group,value);
        add(name,() => {const input = [...filterForm.querySelectorAll(`input[name="ct_${group}"]`)].find(valueInput=>valueInput.value===value); input.checked=false; applyFilters();});
      }));
      for (const [key,input] of [['min',minInput],['max',maxInput]]) if (state[key] !== null) add(`${labels[key]}: ${input.value}`,() => {input.value=''; applyFilters();});
      const count = container.childElementCount;
      const indicator = root.querySelector('[data-ct-cl-filter-count]'); indicator.hidden = count === 0; indicator.textContent = String(count);
      container.hidden = count === 0;
      if (count) {const button = text('button',labels.clear); button.type='button'; button.addEventListener('click',clearFilters); container.append(button);}
    }
    function pagination(total) {
      const container = root.querySelector('[data-ct-cl-pagination]');
      container.replaceChildren();
      const pages = Math.ceil(total/pageSize); container.hidden = pages <= 1;
      const add = (label,value,disabled,active) => {
        const button = text('button',label); button.type='button'; button.disabled=disabled;
        if (active) button.setAttribute('aria-current','page');
        button.setAttribute('aria-label',active?`${labels.page} ${value}`:label);
        button.addEventListener('click',() => {page=value; render(); root.querySelector('.ct-cl-main').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});});
        container.append(button);
      };
      add('←',page-1,page===1,false); container.lastChild.setAttribute('aria-label',labels.previous);
      for(let value=1;value<=pages;value++) if(value===1 || value===pages || Math.abs(value-page)<2) add(String(value),value,false,value===page); else if(value===page-2 || value===page+2) container.append(text('span','…'));
      add('→',page+1,page===pages,false); container.lastChild.setAttribute('aria-label',labels.next);
    }
    function render(save = true) {
      const matching = [];
      records.forEach(record => {
        const variants = record.product.variants.filter(variant => variantMatches(record.product,variant,state));
        record.card.hidden = true;
        if(variants.length){renderVariant(record,variants); matching.push(record);}
      });
      const sort = root.querySelector('[data-ct-cl-sort]').value;
      if(sort === 'price-ascending') matching.sort((a,b)=>a.variant.price-b.variant.price);
      if(sort === 'price-descending') matching.sort((a,b)=>b.variant.price-a.variant.price);
      const maxPage = Math.max(1,Math.ceil(matching.length/pageSize)); page = Math.min(Math.max(1,page),maxPage);
      matching.forEach((record,index)=>{list.append(record.card); record.card.hidden = index < (page-1)*pageSize || index >= page*pageSize;});
      root.querySelector('[data-ct-cl-result-count]').textContent = format(labels.products,matching.length);
      root.querySelector('[data-ct-cl-show-results]').textContent = format(labels.show,matching.length);
      root.querySelector('[data-ct-cl-empty]').hidden = matching.length > 0;
      updateCounts(); chips(); pagination(matching.length);
      if(save) updateUrl();
    }
    function applyFilters() {
      if (!complete) return;
      const next = getState();
      const invalid = next.min !== null && next.max !== null && next.min > next.max;
      root.querySelector('[data-ct-cl-range-error]').hidden = !invalid;
      if (invalid || !minInput.checkValidity() || !maxInput.checkValidity()) return;
      state = next; page = 1; render();
    }
    function clearFilters() {
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(input=>input.checked=false);
      minInput.value=''; maxInput.value=''; records.forEach(record=>record.selectedColor=''); applyFilters();
    }
    function compareBar() {
      root.querySelector('[data-ct-cl-compare-bar]').hidden = selections.size === 0;
      root.querySelector('[data-ct-cl-compare-count]').textContent = format(labels.selected,selections.size);
      root.querySelector('[data-ct-cl-open-compare]').disabled = selections.size < 2;
    }
    function clearComparison() {
      selections.clear(); root.querySelectorAll('[data-ct-cl-compare]').forEach(input=>input.checked=false);
      root.querySelector('[data-ct-cl-compare-status]').textContent=''; compareBar();
    }
    function openComparison() {
      const products = [...selections.values()]; if (products.length < 2) return;
      const table = document.createElement('table'); const header=document.createElement('tr'); header.append(text('th',labels.model));
      products.forEach(({product,variant})=>{const cell=document.createElement('th'); cell.scope='col'; if(product.image){const image=document.createElement('img'); image.src=variant?.image||product.image; image.alt=product.title; image.loading='lazy'; cell.append(image);} cell.append(text('strong',product.title)); header.append(cell);});
      table.append(header);
      for(const key of ['price','motor','battery','range','payload','height']){
        const row=document.createElement('tr'); const heading=text('th',labels[key]); heading.scope='row'; row.append(heading);
        products.forEach(({product,variant})=>row.append(text('td',key==='price'?variant.priceText:product[key]||'—'))); table.append(row);
      }
      const row=document.createElement('tr'); row.append(text('th',''));
      products.forEach(({product,variant})=>{const cell=document.createElement('td');const link=text('a',labels.view_product,'ct-cl-button');link.href=`${product.url}?variant=${variant.id}`;cell.append(link);row.append(cell);}); table.append(row);
      root.querySelector('[data-ct-cl-compare-table]').replaceChildren(table); compareDialog.showModal();
    }
    root.addEventListener('click',event=>{
      const button=event.target.closest('button');
      if(!button) return;
      if(button.hasAttribute('data-ct-cl-view')) setView(button.dataset.ctClView);
      if(button.hasAttribute('data-ct-cl-open-filters')){filterDialog.showModal(); document.documentElement.classList.add('ct-cl-modal-open');}
      if(button.hasAttribute('data-ct-cl-close-filters') || button.hasAttribute('data-ct-cl-show-results')) closeFilters();
      if(button.hasAttribute('data-ct-cl-clear')) clearFilters();
      if(button.hasAttribute('data-ct-cl-clear-compare')) clearComparison();
      if(button.hasAttribute('data-ct-cl-open-compare')) openComparison();
      if(button.hasAttribute('data-ct-cl-close-compare')) compareDialog.close();
      if(button.hasAttribute('data-ct-cl-retry')) location.reload();
      if(button.hasAttribute('data-ct-cl-color')){const record=records.find(record=>record.card===button.closest('[data-ct-cl-card]')); record.selectedColor=button.dataset.ctClColor; renderVariant(record,record.matching);}
    });
    root.addEventListener('change',event=>{
      if(filterForm.contains(event.target)) applyFilters();
      if(event.target.hasAttribute('data-ct-cl-sort')){const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.searchParams.delete('ct_page');location.assign(url);}
      if(event.target.hasAttribute('data-ct-cl-compare')){
        const checkbox=event.target; const id=checkbox.dataset.ctClCompare;
        if(!checkbox.checked) selections.delete(id);
        else if(selections.size===3){checkbox.checked=false; root.querySelector('[data-ct-cl-compare-status]').textContent=labels.limit;}
        else {const record=records.find(record=>String(record.product.id)===id);selections.set(id,{product:record.product,variant:record.variant});root.querySelector('[data-ct-cl-compare-status]').textContent='';}
        compareBar();
      }
    });
    filterForm.addEventListener('submit',event=>{event.preventDefault();applyFilters();closeFilters();});
    [minInput,maxInput].forEach(input=>input.addEventListener('input',()=>{clearTimeout(priceTimer);priceTimer=setTimeout(applyFilters,250);}));
    [filterDialog,compareDialog].forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target!==dialog) return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) dialog.close();}));
    async function loadProducts() {
      const status=root.querySelector('[data-ct-cl-load-status]');
      const expected=Number(root.dataset.totalProducts);
      let next=root.querySelector('[data-ct-cl-next]')?.getAttribute('href');
      if (Number(params.get('page')) > 1) {const first = new URL(location.href); first.searchParams.delete('page'); next = first.href; records = []; list.replaceChildren();}
      const visited=new Set();
      if(records.length<expected){status.hidden=false;status.textContent=labels.loading;}
      try {
        while(next && records.length<expected){
          const url=new URL(next,location.href);url.searchParams.set('section_id',root.dataset.sectionId);url.searchParams.delete('ct_page');
          if(visited.has(url.href)||visited.size>=100) throw new Error('Pagination did not complete');
          visited.add(url.href);
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Collection unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const section=doc.querySelector('[data-ct-cl-root]');if(!section)throw new Error('Collection section unavailable');
          const ids=new Set(records.map(record=>record.product.id));
          section.querySelectorAll('[data-ct-cl-card]').forEach(card=>{const record=readRecord(card);if(!ids.has(record.product.id)){records.push(record);list.append(card);ids.add(record.product.id);}});
          next=section.querySelector('[data-ct-cl-next]')?.getAttribute('href');
        }
        if(records.length<expected)throw new Error('Product set is incomplete');
        createOptions();records.forEach(createSwatches);complete=true;fields.disabled=false;status.hidden=true;render();
      }catch{status.hidden=true;root.querySelector('[data-ct-cl-load-error]').hidden=false;root.querySelector('[data-ct-cl-native-pagination]').style.display='block';root.classList.remove('ct-cl-ready');if(media.matches){filterDialog.close();}records.forEach(record=>record.card.hidden=false);}
    }
    loadProducts();
  }
  const initializeAll = (scope=document) => scope.querySelectorAll('[data-ct-cl-root]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeAll());else initializeAll();
  document.addEventListener('shopify:section:load',event=>initializeAll(event.target));
})();

